import type { OptionsDocument, TaskTemplateGroup } from 'paintscout'
import type { TaskTemplateOption } from '..'

export function getTaskTemplateOptions(args: {
  options: OptionsDocument
  includeDeleted?: boolean
  excludeEmpty?: boolean
}): TaskTemplateOption[] {
  const { options, includeDeleted = false, excludeEmpty = false } = args
  const { taskTemplates } = options.options

  if (!taskTemplates) {
    return []
  }

  return taskTemplates.order
    .map((orderItem) => {
      const template = taskTemplates.values[orderItem] as TaskTemplateGroup
      if (!template || (!includeDeleted && template.deleted)) {
        return null
      }
      return {
        key: orderItem,
        label: template.label || '',
        deleted: template.deleted,
        order: template.order || [],
        values: template.values || {}
      } as TaskTemplateOption
    })
    .filter(Boolean)
    .filter((option) => {
      if (excludeEmpty) {
        return option!.order.length > 0
      }
      return true
    })
}
